/* SET STATE */
export const SET_STATE_SURVEYCATEGORIE = "SET_STATE_SURVEYCATEGORIE"

/* SURVEYCATEGORIES */
export const GET_SURVEYCATEGORIES = "GET_SURVEYCATEGORIES"
export const GET_SURVEYCATEGORIES_SUCCESS = "GET_SURVEYCATEGORIES_SUCCESS"
export const GET_SURVEYCATEGORIES_FAIL = "GET_SURVEYCATEGORIES_FAIL"

/* SURVEYCATEGORIE */
export const GET_SURVEYCATEGORIE = "GET_SURVEYCATEGORIE"
export const GET_SURVEYCATEGORIE_SUCCESS = "GET_SURVEYCATEGORIE_SUCCESS"
export const GET_SURVEYCATEGORIE_FAIL = "GET_SURVEYCATEGORIE_FAIL"

/**
 * ADD SURVEYCATEGORIE
 */
 export const ADD_NEW_SURVEYCATEGORIE = "ADD_NEW_SURVEYCATEGORIE"
 export const ADD_SURVEYCATEGORIE_SUCCESS = "ADD_SURVEYCATEGORIE_SUCCESS"
 export const ADD_SURVEYCATEGORIE_FAIL = "ADD_SURVEYCATEGORIE_FAIL"

 /**
 * UPDATE SURVEYCATEGORIE
 */
export const UPDATE_SURVEYCATEGORIE = "UPDATE_SURVEYCATEGORIE"
export const UPDATE_SURVEYCATEGORIE_STATUS = "UPDATE_SURVEYCATEGORIE_STATUS"
export const UPDATE_SURVEYCATEGORIE_SUCCESS = "UPDATE_SURVEYCATEGORIE_SUCCESS"
export const UPDATE_SURVEYCATEGORIE_FAIL = "UPDATE_SURVEYCATEGORIE_FAIL"

/**
 * DELETE SURVEYCATEGORIE
 */
export const DELETE_SURVEYCATEGORIE = "DELETE_SURVEYCATEGORIE"
export const DELETE_SURVEYCATEGORIE_SUCCESS = "DELETE_SURVEYCATEGORIE_SUCCESS"
export const DELETE_SURVEYCATEGORIE_FAIL = "DELETE_SURVEYCATEGORIE_FAIL"
